import { render } from "./ImageViewport.vue?vue&type=template&id=2bbb3a51"
import script from "./ImageViewport.vue?vue&type=script&lang=js"
export * from "./ImageViewport.vue?vue&type=script&lang=js"

import "./ImageViewport.vue?vue&type=style&index=0&id=2bbb3a51&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__